import React from 'react';
import { array, func, string, object, bool } from 'prop-types';
import { ifNullOrWhitespace, isArray } from 'vdlib';
import placeholdeImage from 'static/img/car-photo.png';
import ImageGallery from 'components/common/ImageGallery';
import { Modal } from 'antd';
import { I18n as I } from 'react-redux-i18n';
import { AuctionStatuses, LoaderOverlay, isFunc, PartyTypes } from 'vdlib';
import Dropzone from 'components/common/Dropzone';
import LookupsHelper from 'lib/LookupsHelper';
import ManageImagesModal from './ManageImagesModal';
import { getImageUrl } from 'lib/Utils';

const defaultClassName = 'col-12';

const imagesToUrls = (imagesArr, folderNumber) =>
  imagesArr.map(p => ({
    id: p.Id,
    original: getImageUrl(p.Filename, folderNumber),
    thumbnail: getImageUrl(p.ThumbnailFilename, folderNumber),
  }));

class AuctionImages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUploadIdx: -1,
      filesToUpload: [],
      imageUrls: isArray(props.images)
        ? imagesToUrls(props.images, props.auction.FolderNumber)
        : [],
      showDropzone: false,
      showManageModal: false,
      maxImagesNumber: false,
      completed: false,
    };
  }

  hide = () => {
    if (isFunc(this.props.onImagesChanged)) {
      this.props.onImagesChanged();
    }

    this.setState({
      showDropzone: false,
      completed: false,
      maxImagesNumber: false,
    });
  };
  show = () => this.setState({ showDropzone: true });
  hideManageModal = () => this.setState({ showManageModal: false });
  showManageModal = () => this.setState({ showManageModal: true });

  componentWillReceiveProps(nextProps) {
    const {
      data,
      deleteImages,
      images,
      onClearReorderImages,
      onImagesChanged,
      removeImageLicensePlate,
      reorderImages,
      uploading,
    } = nextProps;
    const uploadFinished =
      this.props.uploading === true && uploading !== true && !!data;
    const deleteImagesFinished = !this.props.deleteImages && !!deleteImages;
    const imagesReordered = !this.props.reorderImages && !!reorderImages;
    const removeLicensePlateFinished =
      !this.props.removeImageLicensePlate && !!removeImageLicensePlate;

    if (removeLicensePlateFinished) {
      onImagesChanged();
    } else if (uploadFinished) {
      const { currentUploadIdx, filesToUpload } = this.state;
      const newIdx = currentUploadIdx + 1;

      if (newIdx < filesToUpload.length) {
        this.setState(
          {
            currentUploadIdx: newIdx,
            filesToUpload,
          },
          () => this.props.upload(filesToUpload[newIdx])
        );
        // all uploads finished, refetch images
      } else if (isFunc(onImagesChanged)) {
        this.setState({ completed: true });
        onImagesChanged();
      }
    } else if (deleteImagesFinished) {
      onImagesChanged();
    } else if (imagesReordered) {
      onClearReorderImages();
      onImagesChanged();
    } else if (isArray(images)) {
      const { auction } = nextProps;
      const { FolderNumber } = auction || {};

      this.setState({ imageUrls: imagesToUrls(images, FolderNumber) });
    }
  }

  handleDrop = filesToUpload => {
    if (filesToUpload.length + this.props.images.length > 29) {
      this.setState({
        maxImagesNumber: true,
      });
    } else {
      this.setState({
        filesToUpload: filesToUpload,
        currentUploadIdx: 0,
        maxImagesNumber: false,
      });
      this.props.upload(filesToUpload[0]);
    }
  };

  canUploadImages = () => {
    const { auction, auctionStatuses, partyTypes, user } = this.props;
    const { StatusID } = auction || {};
    const { PartyType } = user || {};
    if (
      LookupsHelper.getDescription(auctionStatuses, StatusID) !==
      AuctionStatuses.Pending
    )
      return false;
    const partyType = LookupsHelper.getDescription(partyTypes, PartyType);
    return (
      partyType === PartyTypes.Operator ||
      partyType === PartyTypes.Admin_Insurance
    );
  };

  canManageImages = () => {
    const {
      auction,
      images,
      auctionStatuses,
      fetchingImages,
      partyTypes,
      user,
    } = this.props;
    const { StatusID } = auction || {};
    const { PartyType } = user || {};

    return (
      ((isArray(images) && images.length > 0) || fetchingImages) &&
      LookupsHelper.getDescription(auctionStatuses, StatusID) ===
        AuctionStatuses.Pending &&
      (LookupsHelper.getDescription(partyTypes, PartyType) ===
        PartyTypes.Operator ||
        LookupsHelper.getDescription(partyTypes, PartyType) ===
          PartyTypes.Admin_Insurance)
    );
  };

  render() {
    const {
      auction,
      className,
      deleteImagesPending,
      error,
      fetchingImages,
      onClearRemoveImageLicensePlate,
      onDelete,
      onRemoveLicensePlate,
      onReorderImages,
      removeImageLicensePlate,
      removeImageLicensePlateError,
      removeImageLicensePlatePending,
      reoderImages,
      reorderImagesError,
      reorderImagesPending,
      uploading,
    } = this.props;
    const { currentUploadIdx, filesToUpload, imageUrls } = this.state;

    const { FolderNumber } = auction || {};

    const canManageImages = this.canManageImages();
    return (
      <div
        className={`auction-data-pane ${ifNullOrWhitespace(
          className,
          defaultClassName
        )}`}
      >
        <div className="well clearfix">
          <LoaderOverlay loading={fetchingImages} />
          <div className="images-wrap">
            {isArray(imageUrls) && imageUrls.length > 0 ? (
              <ImageGallery
                items={imageUrls}
                renderFullscreenButton={(onClick, isFullscreen) => (
                  <button
                    type="button"
                    className={`image-gallery-fullscreen-button ${
                      isFullscreen ? ' active' : 'inactive'
                    }`}
                    onClick={onClick}
                  >
                    {!isFullscreen && <i className="fa fa-search-plus" />}
                  </button>
                )}
              />
            ) : (
              <div className="image-placeholder">
                <img src={placeholdeImage} alt="" />
              </div>
            )}
            {canManageImages && (
              <button
                className="btn red image-action-btn"
                style={{ right: 'auto', left: '25px' }}
                onClick={this.showManageModal}
              >
                {I.t('MANAGE')}
              </button>
            )}
            {this.canUploadImages() && (
              <button className="btn blue image-action-btn" onClick={this.show}>
                {I.t('IMAGES_UPLOAD')}
              </button>
            )}
          </div>
        </div>
        <Modal
          footer={[
            <button
              type="button"
              className="btn btn-primary btn-sm float-right"
              onClick={this.hide}
            >
              {I.t('CLOSE')}
            </button>,
          ]}
          onCancel={this.hide}
          title={I.t('IMAGES_UPLOAD')}
          visible={this.state.showDropzone}
        >
          <Dropzone
            accept="images"
            current={currentUploadIdx + 1}
            error={error}
            loading={uploading}
            maxImagesNumber={this.state.maxImagesNumber}
            onDrop={this.handleDrop}
            success={this.state.completed}
            total={filesToUpload.length}
          />
        </Modal>
        {canManageImages && (
          <ManageImagesModal
            deleteImagesPending={deleteImagesPending}
            folderNumber={FolderNumber}
            imageUrls={imageUrls}
            onDelete={onDelete}
            onClearRemoveImageLicensePlate={onClearRemoveImageLicensePlate}
            onRemoveLicensePlate={onRemoveLicensePlate}
            onReorderImages={onReorderImages}
            onHide={this.hideManageModal}
            removeImageLicensePlate={removeImageLicensePlate}
            removeImageLicensePlateError={removeImageLicensePlateError}
            removeImageLicensePlatePending={removeImageLicensePlatePending}
            reorderImages={reoderImages}
            reorderImagesError={reorderImagesError}
            reorderImagesPending={reorderImagesPending}
            show={this.state.showManageModal}
          />
        )}
      </div>
    );
  }
}

AuctionImages.propTypes = {
  className: string,

  deleteImages: object,
  deleteImagesError: object,
  deleteImagesPending: bool,

  images: array,
  onDelete: func,
  onRemoveLicensePlate: func,
  onImagesChanged: func,

  removeImageLicensePlate: object,
  removeImageLicensePlateError: object,
  removeImageLicensePlatePending: bool,
};

export default AuctionImages;
